const fadeOutSeconds = 0.3;
const timeoutSeconds = 5;

class FlashMessages {
  timeout = null;
  container = null;
  progressBar = null;

  async showMessage(message) {
    this.createOrResetContainer(message);

    // Create message element
    const messageElem = document.createElement("div");
    messageElem.classList.add("flash-notice");
    messageElem.textContent = message;
    this.container.appendChild(messageElem);

    // Add progress bar
    this.progressBar = document.createElement("div");
    this.progressBar.classList.add("flash-messages__progress-bar");
    this.container.appendChild(this.progressBar);

    // Start progress bar animation (via CSS transition)
    await this.wait(100);
    this.progressBar.style.setProperty("--progress", "0%");

    // Remove after the timeout
    await this.wait(timeoutSeconds * 1000);
    this.fadeOut();
  }

  createOrResetContainer() {
    this.container = document.querySelector(".flash-messages--floating");
    if (this.container) {
      // Remove existing messages
      this.container.innerHTML = "";
      this.container.classList.remove("flash-messages--fade-out");
      this.progressBar.remove();
      if (this.timeout) clearTimeout(this.timeout);
    }

    if (!this.container) {
      this.container = document.createElement("div");
      this.container.classList.add(
        "flash-messages",
        "flash-messages--floating"
      );
      document.body.appendChild(this.container);
      this.container.style.setProperty("--fadeout", `${fadeOutSeconds}s`);
      this.container.style.setProperty("--timeout", `${timeoutSeconds}s`);

      this.container.addEventListener("click", () => {
        this.fadeOut();
      });
    }
  }

  async fadeOut() {
    this.container.classList.add("flash-messages--fade-out");
    // Wait for the animation and then remove
    await this.wait(fadeOutSeconds * 1000);
    this.container.remove();
  }

  restartTimeout(fn, delay) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(fn, delay);
  }

  async wait(ms) {
    return new Promise((resolve) => this.restartTimeout(resolve, ms));
  }
}

window.flashMessages = new FlashMessages();
